<template>
  <div class="loan_page">
    <van-nav-bar :title="$t('q61')" class="header_b">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>
    <div class="u_bg"></div>
    <div class="content_re">
      <div class="loan_card credit_card">
        <div class="card_head">
          <div class="card_tit">{{ $t("q62") }}</div>
          <div class="card_sub">{{ $t("q63") }}</div>
        </div>
        <div class="credit_info">
          <div class="credit_amount">
            <!-- <span class="amount_symbol">$</span> -->
            <span class="amount_num">{{
              formatAmount(loanDetail.max_quota)
            }}</span>
          </div>
          <div class="credit_label">{{ $t("q64") }}</div>
        </div>
        <div class="quota_info">
          <div class="quota_item">
            <span class="quota_label">{{ $t("q101") }}</span>
            <span class="quota_value"
              >{{ loanDetail.min_quota }} - {{ loanDetail.max_quota }}</span
            >
          </div>
          <div class="quota_item">
            <span class="quota_label">{{ $t("q102") }}</span>
            <span class="quota_value highlight"
              >{{ formatRate(loanDetail.daily_rate) }}%</span
            >
          </div>
        </div>
      </div>

      <div class="form_section">
        <div class="section_title">
          <span class="title_icon"></span>
          <span>{{ $t("q66") }}</span>
        </div>
        <div class="custom_input">
          <input
            type="number"
            v-model="customAmount"
            :placeholder="$t('q67')"
            class="input_field"
            :min="loanDetail.min_quota"
            :max="loanDetail.max_quota"
          />
        </div>
        <div class="quick_amounts">
          <span
            :class="[
              'quick_btn',
              { active: customAmount == loanDetail.min_quota },
            ]"
            @click="customAmount = loanDetail.min_quota.toString()"
          >
            {{ loanDetail.min_quota }}
          </span>
          <span
            :class="[
              'quick_btn',
              { active: customAmount == loanDetail.max_quota },
            ]"
            @click="customAmount = loanDetail.max_quota.toString()"
          >
            {{ loanDetail.max_quota }}
          </span>
        </div>
      </div>

      <div class="form_section">
        <div class="section_title">
          <span class="title_icon"></span>
          <span>{{ $t("q68") }}</span>
        </div>
        <div class="term_options">
          <div
            v-for="(config, index) in loanConfigs"
            :key="config.uuid || index"
            :class="['term_item', { active: selectedIndex === index }]"
            @click="selectConfig(index)"
          >
            <div class="term_value">{{ config.term }}{{ $t("q105") }}</div>
            <div class="term_interest">
              {{ $t("q76") }} {{ formatRate(config.daily_rate) }}%
            </div>
          </div>
        </div>
      </div>

      <div class="info_card">
        <div class="info_row">
          <div class="info_label">{{ $t("q106") }}</div>
          <div class="info_value">{{ formatAmount(inputAmount) }}</div>
        </div>
        <div class="info_row">
          <div class="info_label">{{ $t("q70") }}</div>
          <div class="info_value">{{ formatAmount(interestAmount) }}</div>
        </div>
        <div class="info_row">
          <div class="info_label">{{ $t("q69") }}</div>
          <div class="info_value highlight">
            {{ formatAmount(totalAmount) }}
          </div>
        </div>
        <!-- <div class="info_row">
          <div class="info_label">{{ $t("q71") }}</div>
          <div class="info_value">
            ${{ formatAmount(dailyPayment) }}/{{ $t("q105") }}
          </div>
        </div> -->
      </div>

      <div class="submit_btn" @click="submitLoan">
        {{ $t("q72") }}
      </div>

      <div class="tips">
        <p>{{ $t("q73") }}</p>
        <p>{{ $t("q74") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../../router";

export default {
  data() {
    return {
      loanConfigs: [],
      selectedIndex: 0,
      customAmount: "",
      userInfo: {},
    };
  },
  computed: {
    loanDetail() {
      return (
        this.loanConfigs[this.selectedIndex] || {
          term: 7,
          daily_rate: 0,
          max_quota: 0,
          min_quota: 0,
        }
      );
    },
    inputAmount() {
      return this.customAmount ? parseInt(this.customAmount) : 0;
      // return Math.max(
      //   this.loanDetail.min_quota,
      //   Math.min(
      //     this.loanDetail.max_quota,
      //     amount || this.loanDetail.min_quota,
      //   ),
      // );
    },
    dailyRate() {
      return parseFloat(this.loanDetail.daily_rate) || 0;
    },
    interestAmount() {
      return Math.round(
        this.inputAmount * this.dailyRate * this.loanDetail.term,
      );
    },
    totalAmount() {
      return this.inputAmount + this.interestAmount;
    },
  },
  methods: {
    formatAmount(amount) {
      if (typeof amount !== "number") {
        amount = parseInt(amount) || 0;
      }
      return amount.toLocaleString();
    },
    formatRate(rate) {
      const num = parseFloat(rate);
      return num ? (num * 100).toFixed(4) : "0.0000";
    },
    back() {
      return window.history.back();
    },
    selectConfig(index) {
      this.selectedIndex = index;
      this.customAmount = "";
    },
    submitLoan() {
      const amount = this.inputAmount;
      if (!amount || amount <= 0) {
        this.$toast(this.$t("q77"));
        return;
      }
      if (amount < this.loanDetail.min_quota) {
        this.$toast(`${this.$t("q103")} ${this.loanDetail.min_quota}`);
        return;
      }
      if (amount > this.loanDetail.max_quota) {
        this.$toast(`${this.$t("q104")} ${this.loanDetail.max_quota}`);
        return;
      }
      this.$http({
        method: "post",
        url: "loanApply",
        data: {
          product_id: this.loanDetail.uuid,
          quota: amount,
          user_name: this.userInfo.username,
          user_id: this.userInfo.id,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$router.push({
            path: "/LoanRecords?user_id=" + this.userInfo.id,
          });
          this.$toast.success(this.$t("q79"));
          this.$toast(this.$t(res.msg));
        } else {
          this.$toast(this.$t(res.msg));
        }
      });
    },
    getLoanFn() {
      this.$http({
        method: "get",
        url: "loanConfig",
      })
        .then((res) => {
          if (res && res.data2 && res.data2.length > 0) {
            this.loanConfigs = res.data2.map((item) => ({
              uuid: item.uuid,
              term: parseInt(item.term) || 7,
              daily_rate: parseFloat(item.daily_rate) || 0,
              max_quota: parseInt(item.max_quota) || 0,
              min_quota: parseInt(item.min_quota) || 0,
              repay_cycle: parseInt(item.repay_cycle) || 7,
            }));
            this.selectedIndex = 0;
          }
        })
        .catch((err) => {
          console.error("Failed to fetch loan config:", err);
          this.loanConfigs = [
            {
              uuid: null,
              term: 7,
              daily_rate: 0,
              max_quota: 0,
              min_quota: 0,
              repay_cycle: 7,
            },
          ];
        });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    this.getLoanFn();
    this.getUserInfo();
  },
};
</script>

<style scoped lang="less">
.loan_page {
  position: relative;
  background-color: #101012;
  min-height: 100vh;
  padding-top: 100px;
  box-sizing: border-box;

  .content_re {
    position: relative;
    padding: 20px;
    padding-bottom: 120px;
  }

  .header_b {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .u_bg {
    background: linear-gradient(to right, #efcba7, #dcab76);
    height: 250px;
    position: absolute;
    width: 100%;
    top: 100px;
    border-radius: 0 0 40px 40px;
  }

  .loan_card {
    position: relative;
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    border-radius: 16px;
    padding: 30px;
    margin-bottom: 30px;

    .card_head {
      margin-bottom: 30px;

      .card_tit {
        font-size: 32px;
        font-weight: bold;
        color: #e6b98a;
      }

      .card_sub {
        font-size: 24px;
        color: #666;
        margin-top: 8px;
      }
    }

    .credit_info {
      text-align: center;
      margin-bottom: 20px;

      .credit_amount {
        display: flex;
        align-items: baseline;
        justify-content: center;

        .amount_symbol {
          font-size: 36px;
          color: #e6b98a;
          font-weight: bold;
        }

        .amount_num {
          font-size: 72px;
          font-weight: bold;
          color: #fff;
          margin-left: 8px;
        }
      }

      .credit_label {
        font-size: 26px;
        color: #666;
        margin-top: 10px;
      }
    }

    .quota_info {
      display: flex;
      justify-content: space-around;
      padding-top: 20px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);

      .quota_item {
        text-align: center;

        .quota_label {
          display: block;
          font-size: 22px;
          color: #666;
          margin-bottom: 8px;
        }

        .quota_value {
          font-size: 24px;
          color: #fff;
          font-weight: bold;

          &.highlight {
            color: #e6b98a;
          }
        }
      }
    }
  }

  .form_section {
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;

    .section_title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .title_icon {
        width: 8px;
        height: 30px;
        background: linear-gradient(180deg, #efcba7, #dcab76);
        border-radius: 4px;
        margin-right: 12px;
      }

      span:last-child {
        font-size: 28px;
        font-weight: bold;
        color: #e6b98a;
      }
    }

    .custom_input {
      .input_field {
        width: 100%;
        padding: 24px;
        background-color: #1a1a1a;
        border: 1px solid #333;
        border-radius: 12px;
        color: #fff;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        box-sizing: border-box;

        &::placeholder {
          color: #666;
          font-weight: normal;
        }

        &:focus {
          outline: none;
          border-color: #e6b98a;
        }
      }
    }

    .quick_amounts {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 15px;

      .quick_btn {
        padding: 12px 20px;
        background-color: #1a1a1a;
        border: 1px solid #333;
        border-radius: 8px;
        color: #999;
        font-size: 22px;
        transition: all 0.3s ease;

        &.active {
          background-color: rgba(230, 185, 138, 0.15);
          border-color: #e6b98a;
          color: #e6b98a;
        }
      }
    }

    .term_options {
      display: flex;
      flex-wrap: wrap;
      gap: 15px;

      .term_item {
        flex: 1;
        min-width: calc(50% - 7.5px);
        padding: 20px;
        text-align: center;
        background-color: #1a1a1a;
        border: 2px solid #333;
        border-radius: 12px;
        transition: all 0.3s ease;

        .term_value {
          color: #fff;
          font-size: 28px;
          font-weight: bold;
        }

        .term_interest {
          color: #666;
          font-size: 22px;
          margin-top: 8px;
        }

        &.active {
          border-color: #e6b98a;
          background-color: rgba(230, 185, 138, 0.1);

          .term_value {
            color: #e6b98a;
          }

          .term_interest {
            color: #e6b98a;
          }
        }
      }
    }
  }

  .info_card {
    background: linear-gradient(120deg, #212121, #313131);
    border: 1px solid #766350;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 30px;

    .info_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #2a2a2a;

      &:last-child {
        border-bottom: none;
      }

      .info_label {
        font-size: 26px;
        color: #999;
      }

      .info_value {
        font-size: 28px;
        font-weight: bold;
        color: #fff;

        &.highlight {
          color: #e6b98a;
        }
      }
    }
  }

  .submit_btn {
    width: 100%;
    padding: 30px;
    background: linear-gradient(90deg, #efcba7, #dcab76);
    border-radius: 16px;
    text-align: center;
    color: #1a1a1a;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 20px rgba(230, 185, 138, 0.3);

    &:active {
      opacity: 0.85;
      transform: scale(0.98);
    }
  }

  .tips {
    padding: 20px;
    background-color: rgba(230, 185, 138, 0.08);
    border: 1px solid rgba(230, 185, 138, 0.2);
    border-radius: 12px;

    p {
      font-size: 22px;
      color: #999;
      line-height: 1.6;

      &:first-child {
        margin-bottom: 8px;
      }
    }
  }
}

.van-nav-bar {
  background-color: #1c1c1c;
}

@media screen and (min-width: 431px) {
  .loan_page {
    max-width: 430px;
    width: calc(100% - 20px);
    margin: 20px auto;
    padding-top: 0;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
    min-height: calc(100vh - 60px);
    border-radius: 20px;
    overflow: hidden;

    .header_b {
      position: sticky !important;
      top: 0;
    }

    .u_bg {
      top: 44px;
      height: 180px;
    }

    .content_re {
      padding: 15px;
      padding-bottom: 60px;
    }

    .loan_card {
      padding: 20px;
      margin-bottom: 20px;

      .card_head {
        margin-bottom: 20px;

        .card_tit {
          font-size: 24px;
        }

        .card_sub {
          font-size: 16px;
        }
      }

      .credit_info {
        margin-bottom: 15px;

        .credit_amount {
          .amount_symbol {
            font-size: 24px;
          }

          .amount_num {
            font-size: 48px;
          }
        }

        .credit_label {
          font-size: 16px;
        }
      }

      .quota_info {
        padding-top: 15px;

        .quota_item {
          .quota_label {
            font-size: 12px;
          }

          .quota_value {
            font-size: 16px;
          }
        }
      }
    }

    .form_section {
      padding: 15px;
      margin-bottom: 15px;

      .section_title {
        margin-bottom: 15px;

        .title_icon {
          height: 20px;
        }

        span:last-child {
          font-size: 20px;
        }
      }

      .custom_input {
        .input_field {
          padding: 16px;
          font-size: 24px;
        }
      }

      .quick_amounts {
        gap: 8px;
        margin-top: 12px;

        .quick_btn {
          padding: 8px 15px;
          font-size: 14px;
        }
      }

      .term_options {
        gap: 10px;

        .term_item {
          padding: 12px;

          .term_value {
            font-size: 18px;
          }

          .term_interest {
            font-size: 14px;
          }
        }
      }
    }

    .info_card {
      padding: 15px;
      margin-bottom: 20px;

      .info_row {
        padding: 10px 0;

        .info_label {
          font-size: 14px;
        }

        .info_value {
          font-size: 16px;
        }
      }
    }

    .submit_btn {
      padding: 16px;
      font-size: 20px;
      margin-bottom: 15px;
    }

    .tips {
      padding: 12px;

      p {
        font-size: 12px;
      }
    }
  }

  ::v-deep .van-nav-bar__content {
    height: 44px;
  }

  ::v-deep .van-nav-bar__title {
    font-size: 16px;
  }
}
</style>
